/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-perf/jsx-no-new-object-as-prop */
/* eslint-disable react-perf/jsx-no-new-function-as-prop */
/* eslint-disable arrow-body-style */
import React from 'react'
import { BrandLogoIcon, IcoMoon } from '@usap/uicomponents'
import { FallbackHeaderContainer } from './FallbackHeader.css'

const FallbackHeader = () => {
  const redirectToHome = () => {
    window.location.href = '/'
  }

  return (
    <FallbackHeaderContainer>
      <IcoMoon
        onClick={redirectToHome}
        icon={BrandLogoIcon}
        width="231px"
        height="34px"
        style={{ cursor: 'pointer' }}
      />
    </FallbackHeaderContainer>
  )
}

export default FallbackHeader
